import { useQueryClient, type QueryKey } from "@tanstack/react-query";

import { ApiError } from "../api/errors";
import { refreshAccessScope } from "../api/session";

/**
 * After a 403 or a 409, read the access scope and the given queries again: the role hint that
 * offered the control, or the list the user acted on, may be stale (spec A4, Risks).
 */
export function useRefetchOnRefusal(...keys: QueryKey[]) {
  const queryClient = useQueryClient();
  return async (error: unknown) => {
    if (!(error instanceof ApiError) || (error.status !== 403 && error.status !== 409)) return;
    await Promise.all([
      refreshAccessScope(queryClient),
      ...keys.map((queryKey) => queryClient.invalidateQueries({ queryKey })),
    ]);
  };
}
